<div class="emds delete-modal-container">
    <div class="modal-default modal-flex" id="delete-modal">
        <div class="modal-header">
            <h5 class="modal-title">
                Delete View Option Filter
            </h5>
        </div>
        <div class="modal-body remove-padding">
           <p>Are you sure that you want to delete <b> {{ title }} </b> from RPN Viewing Options?</p>
        </div>
        <div class="modal-footer">
            <button id="rpn-modal-apply" class="btn-primary btn pull-right" (click)="onOk()">
                Yes
            </button>
            <button id="rpn-modal-cancel" class="btn btn-secondary pull-right btn-flush-right" (click)="cancel()">
                Cancel
            </button>
        </div>
    </div>
</div>